
const BASE_URL = 'https://api.coinnexs.com/api';

export interface BtcAddressResponse {
    success: boolean;
    data: {
        address: string;
    };
}

class UserDetailService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            'Content-Type': 'application/json',
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers: {
                    ...headers,
                    ...(options.headers as Record<string, string>),
                },
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`User Detail API Error (${endpoint}):`, error);
            return {
                success: false,
                message: 'Network error. Please try again later.',
            } as unknown as T;
        }
    }

    async getBtcAddress(): Promise<BtcAddressResponse> {
        return this.request<BtcAddressResponse>('/btc-address');
    }
}

export const userDetailService = new UserDetailService();
